@if (form(); as previewForm) {
  <div class="fixed top-4 left-1/2 z-10 inline-flex -translate-x-1/2 items-center gap-1.5">
    <button
      type="button"
      (click)="setPreviewMode('desktop')"
      aria-label="Desktop preview"
      class="inline-flex size-9 cursor-pointer items-center justify-center rounded-lg border transition"
      [class.border-primary-600]="previewMode() === 'desktop'"
      [class.bg-primary-50]="previewMode() === 'desktop'"
      [class.text-primary-600]="previewMode() === 'desktop'"
      [class.border-slate-200]="previewMode() !== 'desktop'"
      [class.bg-white]="previewMode() !== 'desktop'"
      [class.text-slate-500]="previewMode() !== 'desktop'"
      [class.hover:bg-slate-50]="previewMode() !== 'desktop'">
      <app-svg-icon src="assets/icons/laptop.svg" [size]="16" />
    </button>
    <button
      type="button"
      (click)="setPreviewMode('mobile')"
      aria-label="Mobile preview"
      class="inline-flex size-9 cursor-pointer items-center justify-center rounded-lg border transition"
      [class.border-primary-600]="previewMode() === 'mobile'"
      [class.bg-primary-50]="previewMode() === 'mobile'"
      [class.text-primary-600]="previewMode() === 'mobile'"
      [class.border-slate-200]="previewMode() !== 'mobile'"
      [class.bg-white]="previewMode() !== 'mobile'"
      [class.text-slate-500]="previewMode() !== 'mobile'"
      [class.hover:bg-slate-50]="previewMode() !== 'mobile'">
      <app-svg-icon src="assets/icons/cellphone.svg" [size]="16" />
    </button>
  </div>
}

<button
  type="button"
  class="fixed top-4 right-4 z-10 flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg bg-white/90 text-lg text-slate-500 shadow-sm ring-1 ring-slate-200/80 backdrop-blur transition hover:bg-slate-100"
  aria-label="Close"
  (click)="close()">
  ×
</button>

<div class="flex min-h-dvh w-full flex-1 items-start justify-center overflow-y-auto px-6 py-12 sm:px-10">
  @if (loadState.loading()) {
    <p class="py-16 text-sm text-slate-500">Loading preview…</p>
  } @else if (form(); as previewForm) {
    <app-form-preview-card [form]="previewForm" [mode]="previewMode()" />
  } @else {
    <div class="flex max-w-sm flex-col items-center gap-3 px-6 py-16 text-center">
      <p class="text-sm font-medium text-slate-800">No preview available</p>
      <p class="text-sm leading-6 text-slate-500">
        @if (loadError()) {
          This form could not be loaded. Check the slug or open it from the builder.
        } @else {
          Open a form in the builder and use the play icon to preview it here.
        }
      </p>
    </div>
  }
</div>
